import { z } from 'zod';
import { UnitSchema } from './Unit';
import { WardSchema } from './Ward';

export const DistrictSchema = z
  .object({
    code: z.string(),
    codeName: z.string(),
    name: z.string(),
    nameEn: z.string(),
    fullName: z.string(),
    fullNameEn: z.string(),
    provinceCode: z.string(),
    unitId: z.number(),
    unit: UnitSchema,
    wards: z.array(WardSchema),
  })
  .partial();

export type District = z.infer<typeof DistrictSchema>;
